import { Component, Input } from '@angular/core';
import { SPKBatteryRentListComponent } from '../list/spk-battery-rent-list.component';

@Component({
  selector: 'app-status-info-modal',
  templateUrl: 'status-info-modal.component.html',
  styleUrls: ['../list/spk-battery-rent-list.component.scss']
  // styleUrls: ['status-info-modal.component.scss']
})
export class StatusInfoModal {

  constructor(
    public _spkBatteryRentListComponent: SPKBatteryRentListComponent
  ){}

  isOpen: boolean = false;

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
}
